// Modelo compartilhado entre slick-detail e app-product-picklist (e futuramente
// slicks-data-view) — extraído de slick-detail.component.ts pra permitir
// reuso do componente de associação de produtos.
export interface ProdutoCategory {
  id: number;
  title: string;
}

export interface Produto {
  id: number;
  sku: number;
  name: string;
  status: number;
  inputQty: number;
  position: number;
  price: string;
  compare_at_price?: string | null;
  onsale_price: string;
  price_exchange: string;
  thumbnail: string;
  categories?: ProdutoCategory[];
  isSelected?: boolean;
  show_item?: boolean;
  highlight?: boolean;
  define_interval?: boolean;
  show_slider?: boolean;
  comprar_font_color?: string;
  comprar_bg_color?: string;
  adicionar_font_color?: string;
  adicionar_bg_color?: string;
  interval_time?: { start: string; end: string };
  __loading?: boolean;
}

export interface ProdutoShopify {
  id: number;
  title: string;
  sku: number;
  description: string;
  vendor: string;
  name: string;
  product_type: string;
  created_at: string;
  updated_at: string;
  categories?: Array<{ id: number; title: string }>;
  thumbnail: string;
  image: string;
  price: string;
  compare_at_price: string | null;
  inventory_quantity: number;
  product_url: string;

  define_interval?: boolean;
  highlight?: boolean;
  isSelected?: boolean;
  show_item?: boolean;
  comprar_font_color?: string;
  comprar_bg_color?: string;
  adicionar_font_color?: string;
  adicionar_bg_color?: string;
  interval_time?: { start: string; end: string };
}

// Extraído de ProductPicklistComponent pra ser reaproveitado onde mais
// precisar montar um Produto a partir do catálogo bruto (ex: dialog de
// associação de produtos em massa em slicks-data-view).
export function transformProdutoShopify(product: ProdutoShopify): Produto {
  return {
    id: product.id,
    sku: product.id,
    name: product.title,
    status: 1,
    inputQty: product.inventory_quantity,
    position: 0,
    price: product.price,
    compare_at_price: product.compare_at_price,
    onsale_price: product.compare_at_price || '',
    price_exchange: '',
    thumbnail: product.thumbnail,
    categories: Array.isArray(product.categories)
      ? product.categories.map(c => ({ id: Number(c.id), title: String(c.title) }))
      : [],
    isSelected: false,
    show_item: true,
    highlight: false,
    define_interval: false,
    show_slider: false,
    interval_time: { start: '', end: '' },
  };
}
